import { CreatedByUser } from '../../types/apps/apps.types';
import { FeatureName } from '../Feature/feature';

export const nuggetFeaturesV2 = {
  'nugget-configuration': {
    id: 210,
    featureName: FeatureName.NUGGET_CONFIGURATION,
  },
} as const;
export const nuggetFeaturesListV2 = Object.entries(nuggetFeaturesV2).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const nuggetModuleFeaturesV2 = [{ moduleId: 60, featureId: nuggetFeaturesV2['nugget-configuration'].id }];
